export default  {
  bindings: {
    ngDisabled: '<'
  },
  require: {
    ngModel: 'ngModel'
  },
  controller: 'roleSelectController',
  template: require('../views/role.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/components/role.select.component.js